// components.application.rewards.pointsChip

export const POINTS_CHIP = {
  cost: '{{cost}} P',
  claimed: 'Claimed',
  redeem: 'Redeemed',
  locked: 'Locked'
};
